export enum DelegationDataType {
  DELEGATION = 'DELEGATION',
  DELEGATION_INVITATION = 'DELEGATION_INVITATION',
}
